import { BASE_URL, DOWNLOAD_USER_CONSENT_API } from '../endpoints/apiEndpoints'

export async function downloadUserConsentPolicy(payload) {

  const response = await fetch(`${BASE_URL}/${DOWNLOAD_USER_CONSENT_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload), 
  });

  if (!response.ok) {
    let errorMessage = `Failed to download user consent policy: ${response.status}`;
    try {
      const errData = await response.json();
      errorMessage = errData?.message || errorMessage;
    } catch (_) {
      // ignore if not JSON
    }
    throw new Error(errorMessage);
  }
  // Return the actual response for blob processing
  return response.json();
}
